import gastroImage from '../../assets/gastroimage1.png'
import hepatoImage from '../../assets/hepatoimage2.png'
import iconlocal from '../../assets/iconlocalizacao.jpeg'

import './header2.css'

function Header2(){
    return(

        <div>
            <header class="cabecalho"> 

                {/*
                <div className="logo"> 
                    <a href="#inicio"> 
                        <img src={hepatoImage} alt="logo"/> 
                        <img src={gastroImage} alt="logo"/>                        
                    </a>                     
                </div> 
                */}


                <a href="#inicio" class="title">Dr. Marcos Martins Soares Jr - Hepatologista e Gastroenterologista </a>    
                
            </header>
        </div>
    )
}
export default Header2;